/**
 * Access tokens from this API are JWTs (header.payload.signature).
 * Garbage in localStorage (e.g. "null", refresh token only, truncated paste)
 * causes FastAPI/JWT to log: "token contains an invalid number of segments".
 */

export function peekTokenRaw() {
  try {
    const raw = typeof window !== "undefined" ? localStorage.getItem("token") : null;
    return typeof raw === "string" ? raw.trim() : "";
  } catch {
    return "";
  }
}

export function isLikelyJwtAccessToken(value) {
  if (!value || typeof value !== "string") return false;
  const parts = value.split(".");
  return parts.length === 3 && parts.every((p) => p.length > 0);
}

/** Valid JWT string or null (does not mutate storage). */
export function readAccessToken() {
  const t = peekTokenRaw();
  return isLikelyJwtAccessToken(t) ? t : null;
}

/** Axios config fragment: either `{ headers: { Authorization: Bearer … } }` or `{}`. */
export function bearerAuthHeaders() {
  const t = readAccessToken();
  if (!t) return {};
  return { headers: { Authorization: `Bearer ${t}` } };
}

/**
 * If something is stored under "token" but it cannot be a JWT, clear auth keys
 * so we do not keep sending a malformed Authorization header.
 */
export function clearAuthStorageIfTokenMalformed() {
  const raw = peekTokenRaw();
  if (!raw) return;
  if (isLikelyJwtAccessToken(raw)) return;
  try {
    localStorage.removeItem("token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("user");
  } catch {
    // ignore
  }
}
